import angular from 'angular';

angular.module('myConsultApp').directive('inputStaticSelect', () => {
  return {
    templateUrl: 'templates/v2/input-static-select.html',
    restrict: 'E',
    scope: {
      id: '@',
      placeholder: '@',
      titleField: '@',
      initialValue: '=',
      records: '=',
      onSelect: '&',
    },
    link: ($scope, elem) => {
      $scope.isVisible = false;
      $scope.currentData = null;

      $scope.showOptions = () => {
        $scope.isVisible = !$scope.isVisible;
      };

      $scope.selectOption = (option) => {
        $scope.currentData = option[$scope.titleField];
        $scope.onSelect({ option });
      };

      $scope.$watch('initialValue', () => {
        $scope.currentData = $scope.initialValue
          ? $scope.initialValue[$scope.titleField]
          : $scope.placeholder;
      });

      $(document).on('click', (event) => {
        const selectFieldEle = $('.select-field');
        const $target = $(event.target);

        if (
          selectFieldEle !== event.target &&
          !$target.closest('.select-field').length &&
          !selectFieldEle.has(event.target).length
        ) {
          $scope.$apply(() => {
            $scope.isVisible = false;
          });
        }
      });
    },
  };
});
